/* Guided intent and catalogue filters. No model inference beyond the verified source. */
(function (root) {
  'use strict';
  const key = value => String(value || '').normalize('NFKC').toLocaleLowerCase('de').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const extra = { Bremsscheibe: ['bremsscheiben', 'brake disc', 'brake discs'], Bremsbelag: ['bremsbeläge', 'bremsbelaege', 'brake pads'],
    Schlauch: ['schläuche', 'schlaeuche', 'inner tube'], Ladegerät: ['ladegeräte', 'ladegeraete'], Ventil: ['ventile'] };
  const tires = ['reifen', 'tire', 'tires', 'tyre', 'tyres', 'pneu', 'pneus', 'opona'];
  const typeNames = type => [type.label, ...(type.aliases || [])];
  const categoryNames = category => [...(category.legacyTypes || []), ...category.types.flatMap(typeNames)];
  const tireCategory = categories => categories.find(c => c.types.some(t => t.label === 'Tubeless Reifen'));
  const kinds = [
    { id: 'tubeless', label: 'Tubeless', names: ['Tubeless Reifen'] },
    { id: 'tube', label: 'Reifen mit Schlauch', names: ['Reifen mit Schlauch', 'Reifen Schlauch Set', 'Reifen-Set mit Schlauch', 'Reifen- und Schlauchset'] },
    { id: 'solid', label: 'Vollgummi', names: ['Vollgummireifen', 'Vollgummi Reifen'] }
  ];
  function intent(query, categories) {
    const text = key(query);
    if (!text) return null;
    if (tires.includes(text)) { const category = tireCategory(categories); return category ? { category: category.id, family: '', genericTires: true } : null; }
    const matches = categories.flatMap(c => c.types.filter(t => [...typeNames(t), ...(extra[t.label] || [])].some(n => key(n) === text))
      .map(t => ({ category: c.id, family: String(t.id) })));
    if (matches.length === 1) return matches[0];
    const category = categories.filter(c => key(c.label) === text || (c.label === 'Bremsen' && text === 'bremse'));
    return category.length === 1 ? { category: category[0].id, family: '' } : null;
  }
  function analyze(state, source, categories, core) {
    const knownSku = Object.hasOwn(source.skus, core.skuKey(state.query));
    if (knownSku) return { knownSku: true, partQuery: state.query, intent: null, size: false };
    const resolved = core.resolveVehicle(state.query, source.vehicles);
    const partQuery = resolved && state.vehicle === resolved.vehicle.id ? resolved.query : state.query;
    return { knownSku: false, partQuery, intent: intent(partQuery, categories),
      size: /\d+(?:[.,]\d+)?\s*[x×*/]\s*\d+(?:[.,]\d+)?/i.test(partQuery) };
  }
  function step(state, info) {
    if (info.knownSku || state.skipGuide) return '';
    if (!info.partQuery.trim() && !state.category) return 'category';
    if (info.size && !state.tire && !state.family && !/tubeless|vollgummi|solid|schlauch|inner tube/i.test(info.partQuery)) return 'tire';
    if ((info.intent || (!info.partQuery.trim() && state.category)) && !state.vehicle) return 'vehicle';
    return '';
  }
  function allowedTypes(state, categories) {
    const category = categories.find(c => c.id === state.category);
    if (!category) return null;
    if (state.tire) {
      const kind = kinds.find(k => k.id === state.tire);
      if (!kind) return new Set();
      const types = category.types.filter(t => kind.names.some(n => key(n) === key(t.label)));
      return new Set([...kind.names, ...types.flatMap(typeNames)].map(key));
    }
    if (state.family) {
      const type = category.types.find(t => String(t.id) === state.family);
      return new Set(type ? typeNames(type).map(key) : []);
    }
    return new Set(categoryNames(category).map(key));
  }
  function catalogueQuery(state, info, categories, core) {
    if (info.knownSku) return state.query;
    const canonical = info.intent && state.category === info.intent.category;
    const query = info.intent?.genericTires ? 'Reifen' : canonical ? '' : info.partQuery;
    if (query.trim()) return core.storefrontQuery(query);
    const category = categories.find(c => c.id === state.category);
    if (!category) return '';
    const allowed = allowedTypes(canonical && info.intent.family ? { ...state, family: info.intent.family, tire: '' } : state, categories);
    const names = categoryNames(category).filter(n => allowed.has(key(n)));
    return '(' + [...new Set(names)].map(n => 'product_type:' + JSON.stringify(n)).join(' OR ') + ')';
  }
  function savedVehicle(saved, vehicles) {
    if (!saved || !saved.variantName || !saved.brandName) return null;
    const matches = vehicles.filter(v => key(v.brand) === key(saved.brandName) && [v.label, ...v.aliases].some(n => key(n) === key(saved.variantName)));
    return matches.length === 1 ? matches[0] : null;
  }
  const api = { intent, analyze, step, allowedTypes, catalogueQuery, savedVehicle, tireCategory, kinds, key };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.EsvSearchGuide = api;
})(typeof window === 'undefined' ? globalThis : window);
